import React, { useCallback } from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useListingsPanelTelemetry } from '../ListingsPanel.telemetry';
import { withWindow } from '@shared/utils/withWindow';
import { useAccommodationsConsoleConfig } from '@apps/accommodations/AccommodationsConsoleConfigContext';
import { AccommodationListingDTO } from '@apps/accommodations/AccommodationsConsole.types';

interface HotelCTAProps {
  listing: AccommodationListingDTO;
  redirectUrl: string;
}

export const HotelCTA = ({ listing, redirectUrl }: HotelCTAProps) => {
  const telemetry = useListingsPanelTelemetry();
  const config = useAccommodationsConsoleConfig();
  const handleSeeAvailability = useEventCallback(() => {
    telemetry.seeAvailabilityClicked({ joyPlaceId: listing.joyPlaceId || '', hotelName: listing.name });
  });

  const handleClick = useEventCallback(e => {
    if (config.listingsPanel?.listingEntry?.bookingCta?.onButtonClick) {
      e.preventDefault();
      config.listingsPanel.listingEntry.bookingCta.onButtonClick(listing);
    } else {
      withWindow(global => global.open(redirectUrl, '_blank'));
      handleSeeAvailability();
    }
  });

  const getBookingConfig = useCallback(() => {
    return listing?.isPickedByCouple && config.listingsPanel.listingEntry.bookingCta.couplePicks
      ? config.listingsPanel.listingEntry.bookingCta.couplePicks
      : config.listingsPanel.listingEntry.bookingCta.default;
  }, [listing?.isPickedByCouple, config.listingsPanel.listingEntry.bookingCta]);

  const getButtonProps = useCallback(() => {
    const { buttonProps } = getBookingConfig();
    return buttonProps;
  }, [getBookingConfig]);

  return (
    <Flex width={{ _: '100%', md: 'fit-content' }}>
      <ButtonV2
        {...getButtonProps()}
        height={{ _: '48px', md: '40px' }}
        width="100%"
        onClick={handleClick}
        shape="rounded"
      >
        {getBookingConfig().buttonTitle}
      </ButtonV2>
    </Flex>
  );
};
